"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Soletta = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Soletta = (function (_super) {
    __extends(Soletta, _super);
    function Soletta() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.SOLETTA,
            tags: [Tags_1.Tags.SPACE],
            cost: 35,
            metadata: {
                cardNumber: '203',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.heat(7); });
                }),
                description: 'Increase your heat production 7 steps.',
            },
        }) || this;
    }
    Soletta.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, 7);
        return undefined;
    };
    return Soletta;
}(Card_1.Card));
exports.Soletta = Soletta;
//# sourceMappingURL=Soletta.js.map